import {createGlobalStyle} from 'styled-components'

// TODO: Maybe this is better as an id?
const GlobalStyle = createGlobalStyle`
  .shop-header {
    font-family: ${props => props.theme.typography.fontFamilies.ff1};
    font-size: 14px;
  }
`

export default GlobalStyle
